//#region src/invariant.ts
function invariant() {
	throw new Error("Invariant failed");
}
//#endregion
export { invariant };

//# sourceMappingURL=invariant.js.map